import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ForeignLanguageImporter  {
    _originalTypeClassName = "zERP.BO.ForeignLanguageImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ForeignLanguageImporter.translate = translateService;
}
this.info = null;
this.ForeignLanguageImporterKey = null;
this._key = this.ForeignLanguageImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
info:any;
private _ForeignLanguageImporterKey:any;
get ForeignLanguageImporterKey(): any {
    return this._ForeignLanguageImporterKey;
  }
set ForeignLanguageImporterKey(value: any) {
    this._ForeignLanguageImporterKey = value;
    this._key = value;
  }

static parseCEFRLevel(lvl: any): any{return ((lvl == "A2" || lvl == "Α2") ? Domain.CEFRLevel.A2 : (((lvl == "Β1" || lvl == "B1") ? Domain.CEFRLevel.B1 : (((lvl == "Β2" || lvl == "B2") ? Domain.CEFRLevel.B2 : ((lvl == "C1" ? Domain.CEFRLevel.C1 : ((lvl == "C2" ? Domain.CEFRLevel.C2 : Domain.CEFRLevel.A1)))))))));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ForeignLanguageImporterKey == null || $this.ForeignLanguageImporterKey == 0;
            }


}